interface NormalizedPhone {
  dialCode: string;
  phone: string;
}

export const splitPhoneFromE164 = (e164?: string | null): NormalizedPhone | null => {
  if (!e164) return null;

  const cleaned = e164.replace(/[^\d+]/g, "");
  if (!cleaned.startsWith("+")) return null;

  if (cleaned.startsWith("+1")) {
    return {
      dialCode: "+1",
      phone: cleaned.slice(2), 
    };
  }
  
  const match = cleaned.match(/^(\+\d{1,3})(\d+)$/);
  if (!match) return null;

  return {
    dialCode: match[1],
    phone: match[2],
  };
};
